import React from 'react';
import cls from 'classnames';
import Fade from 'react-reveal/Fade';

export const CheckBox = React.forwardRef(({
	className,
	classes,
	id,
	labelNo,
	labelYes,
	checked,
	disabled,
	onClick,
	...props
}, ref) => {
	const rootRef = React.useRef();
	const inputRef = React.useRef();
	const labelRef = React.useRef();
	const captionYesRef = React.useRef();
	const captionNoRef = React.useRef();

	React.useImperativeHandle(ref, () => ({
		root: rootRef.current,
		input: inputRef.current,
		label: labelRef.current,
		yes: captionYesRef.current,
		no: captionNoRef.current,
	}));

	return (
		<div
			ref={rootRef}
			className={cls(classes.root, className)}>
			<Fade bottom>
				<div className={cls(classes.content, {
					[classes.isDisabled]: disabled,
				})}>
					{labelNo && <span
						ref={captionNoRef}
						className={cls(classes.no)}
						onClick={() => onClick(false)}
						dangerouslySetInnerHTML={{
							__html: labelNo,
						}}
					/>}
					<div className={classes.wrapper}>
						<input
							ref={inputRef}
							id={id}
							type='checkbox'
							className={classes.input}
							onClick={(evt) => onClick(evt.currentTarget.checked)}
							checked={checked}
							disabled={disabled}
						/>
						<label ref={labelRef} className={classes.label} htmlFor={id} />
					</div>
					{labelYes && <span
						ref={captionYesRef}
						className={classes.yes}
						onClick={() => onClick(true)}
						dangerouslySetInnerHTML={{
							__html: labelYes,
						}}
					/>}
				</div>
			</Fade>
		</div>
	);
});

export default CheckBox;
